import { backendUrl } from '../Tools';
import { SpotClient } from '../../_GeneratedClients/SpotClient';

export const client = new SpotClient(backendUrl);
